import React , { useState,useEffect} from 'react';
import {
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  ListSubheader
  } from '@material-ui/core'

import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Input from '@material-ui/core/Input';
import { createTheme } from "@mui/material/styles";
import { makeStyles } from '@mui/styles';
import { useDispatch } from 'react-redux';
import {disable, addMultipleSelect,setItems, setAllItems} from 'redux/dropDownStores';

const theme = createTheme({
  spacing: 4,
});

const formControl ={
  margin: theme.spacing(2),
  minWidth: 160,
  maxWidth: 800
}

const selectEmpty ={
  marginTop: theme.spacing(2),
  minWidth:300,
  width:300
}

const useStyle = makeStyles(({
}))

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};
 export default function GroupSelectBox({options, defaultStatus, title}){


   const [selected, setSelected] = useState([])
   const isAllSelected =  options.length > 0 && selected.length === options.length;

   const [isInitialized, setIsInitialized] = useState(false);

   const dispatch = useDispatch()

   const classes = useStyle()


  useEffect(() => {
    if (!isInitialized) return;
    dispatch(setItems({componentName:'reports.districts',Items: selected}))

    if (selected.length > 0) {
    dispatch(disable({componentName:'reports.districts',disabled: false}))
  }
  else {
    dispatch(disable({componentName:'reports.districts',disabled: true}))
  }
 }, [selected]);



 useEffect(() => {
   setIsInitialized(true)
   dispatch(addMultipleSelect({componentName:'reports.districts'}))
   dispatch(disable({componentName:'reports.districts',disabled: true}))
}, [dispatch]);


const isAllSelectedForDistrict = (district) => {
    const districtItems = options[district];
    const selectedItems = selected.filter((item) => districtItems.includes(item));
    return districtItems.length === selectedItems.length;
}
const handleDistrictToggle = (district) => {
    const districtItems = options[district];
    const selectedItems = selected.filter((item) => districtItems.includes(item));
    if (districtItems.length === selectedItems.length) {
      setSelected(selected.filter((item) => !districtItems.includes(item)));
    } else {
      setSelected([...selected, ...districtItems])
}
}

const handleStoreToggle = ({value, district}) => {
    if (selected.includes(value)) {
      setSelected(selected.filter((item) => item !== value));
    } else {
      setSelected([...selected, value]);
    }
    isAllSelectedForDistrict(district) ;
}

console.log(selected);

const isAllDistrictsSelected =()  =>{
  const allStores = Object.values(options).flat();
  const allSelected = allStores.length > 0 && selected.length === allStores.length;
  if(isInitialized){
  dispatch(setAllItems({componentName:'reports.districts',allItems: allSelected}))
  }
  return allSelected;
}

const handleAllDistrictToggle =() =>{
  const allStores = Object.values(options).flat();
  setSelected(isAllDistrictsSelected() ? [] : allStores);
}

return(
<>
<FormControl sx={formControl} >
<InputLabel id="mutiple-checkbox-label">{title}</InputLabel>
  <Select
    labelId="mutiple-checkbox-Id"
    id="mutiple-checkbox"
    sx ={selectEmpty}
    multiple
    value={selected}
    input={<Input />}
    renderValue={(selected) => selected.join(', ')}
    MenuProps={MenuProps}
  >
     <MenuItem >
         <Checkbox
           checked={isAllDistrictsSelected()}
           onClick={() => handleAllDistrictToggle()}
              />
        <ListItemText primary= 'All Districts' />
      </MenuItem>
    {Object.keys(options).map((district) => (
      <React.Fragment key={district}>
      <MenuItem key={district} value={district}>
        <ListSubheader style={{
                  display: 'flex',
                  alignItems: 'left',
                  padding: '0 6px',
                  backgroundColor: 'transparent'
                }}>

         <Checkbox
                checked={isAllSelectedForDistrict(district)}
                onClick={() => handleDistrictToggle(district)}
              />
        <ListItemText primary={district} />

        </ListSubheader>
      </MenuItem>
      {options[district].map((item) => (
        <MenuItem key={item} value={item}>
          <Checkbox sx={{ 'pl':5}}
            checked={selected.indexOf(item) > -1}
            onClick={() => handleStoreToggle({value:item, district})}
          />
          <ListItemText primary={item} />
        </MenuItem>
      ))}
      </React.Fragment>
    ))}
  </Select>
  </FormControl>
  </>
)
    }